const deCom = decodeURIComponent;
const enCom = encodeURIComponent;

const getQueryStringArgs = function (str = '') {
    const qs = str.length > 0 ? str.substring(1) : '';
    const args = {};

    const items = qs.length ? qs.split('&') : [];

    for (let i = 0, len = items.length; i < len; i += 1) {
        const item = items[i].split('=');
        const name = deCom(item[0]);
        const value = deCom(item[1]);

        if (name.length) args[name] = value;
    }

    return args;
};

const addURLParam = function (url, name, value) {
    let result = url;
    result += (result.indexOf('?') === -1) ? '?' : '&';
    result += `${enCom(name)}=${enCom(value)}`;
    return result;
};

const addURLParams = function (url, params = {}) {
    let result = url;
    Object
        .keys(params)
        .forEach(key => {
            result = addURLParam(result, key, params[key]);
        });

    return result;
};

export {
    getQueryStringArgs,
    addURLParam,
    addURLParams
};
